export default {
  RECORDING: 'recording',
  RECORDED: 'recorded',
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  UPLOAD_FAILED: 'upload failed',
  STITCHED: 'stitched',
};
